export const getTranscriptContent = (url) => {
  return fetch(url)
    .then((response) => {
      if (response.ok) return response.text();
      throw new Error();
    })
    .then(formatResponse)
    .catch((error) => {
      throw error;
    });
};

const formatResponse = (text) => {
  const lines = text.split(/\r?\n/);
  let transcriptData = {};
  let currentId = -1;

  const initNewTranscriptData = (data) => {
    currentId = parseInt(data);
    transcriptData[currentId] = {};
  };

  const setTranscriptTime = (data) => {
    transcriptData[currentId] = {time: data};
  };

  const setTranscriptText = (data) => {
    const formattedData = removeHTMLTags(data);
    if (transcriptData[currentId][`text`]) {
      const text = transcriptData[currentId][`text`].concat(' ', formattedData);
      transcriptData[currentId] = {
        ...transcriptData[currentId],
        text: text,
      };
    } else
      transcriptData[currentId] = {
        ...transcriptData[currentId],
        text: formattedData,
      };
  };

  const formatTranscriptData = (data, index, array) => {
    if (index === 0 || array[index - 1] === '') {
      initNewTranscriptData(data);
    } else if (parseInt(array[index - 1]) === currentId) {
      setTranscriptTime(data);
    } else if (data != '') {
      setTranscriptText(data);
    }
  };

  lines.forEach(formatTranscriptData);
  return transcriptData;
};

const removeHTMLTags = (string) => string.replace(/<[a-zA-Z\/][^>]*>/g, '');
